import $ from "jquery";

$(document).ready(function() {
	$('.jsCheckBox').on('change', function () {
		$(this).closest('.checkbox').removeClass('is-error')
	});
});